<template>
	<v-container fluid fill-height>
		<v-layout align-center justify-center>
			<v-flex xs12 sm8 md4>
	    		<v-card elevation="0" color="grey lighten-5">
	        		<v-card-text>
	        			<v-form lazy-validation>
	          				<v-text-field
								v-model="email"
								prepend-icon="person"
								label="Email"
								type="email"
								autofocus
								:error-messages="errors.collect('Email')"
								v-validate="'required|email'"
								:data-vv-name="'Email'"
								box
								@keyup.enter="login"
	          				></v-text-field>
	          				<v-text-field
								v-model="password"
								prepend-icon="lock"
								label="Password"
								type="password"
								:error-messages="errors.collect('Password')"
								v-validate="'required'"
								:data-vv-name="'Password'"
								box
								@keyup.enter="login"
	          				></v-text-field>
	          			</v-form>
	        		</v-card-text>
					<v-card-actions>
						<v-btn class="ml-3 mr-1" @click="login" large block color="primary">Login</v-btn>
					</v-card-actions>
	    		</v-card>
	    	</v-flex>
	  	</v-layout>
	</v-container>
</template>

<script>
export default {
	name: 'login',
	data: () => ({
		email: '',
		password: ''
	}),

	methods: {
		login() {
			this.$validator
				.validateAll()
				.then(result => {
					if (!result) {
						return false
					}

					const { email, password } = this
					this.$store.dispatch('AUTH_REQUEST', { email, password }).then(() => {
						this.$router.replace('/')
					},
					error => {})
				})
				.catch(() => {})
		}
	},

	mounted() {
		this.$store.commit('endProgress')
	}
}
</script>
